

import colors from "../../utils/colors";
import { createUseStyles } from 'react-jss';

var styles = {
  toggleWrapper: function toggleWrapper(props) {return {
      display: 'block',
      width: '6rem',
      height: '3.6rem',
      borderRadius: '3rem',
      border: '1px solid',
      borderColor: props.checked ? colors.blue[600] : colors.neutral[400],
      backgroundColor: props.checked ? colors.blue[600] : colors.neutral[200],
      cursor: 'pointer',
      position: 'relative',
      boxSizing: 'border-box',

      '&:after': {
        content: '""',
        position: 'absolute',
        width: '3.4rem',
        height: '100%',
        backgroundColor: colors.neutral.white,
        boxSizing: 'border-box',
        borderRadius: '50%',
        top: '0px',
        boxShadow: '0 3px 3px rgba(0,0,0,.2)'
      }
    };},
  toggleChecked: {
    transition: '250ms ease-in-out',
    '&:after': {
      transition: '250ms ease-in-out',
      left: '2.4rem'
    }
  },
  toggleUnchecked: {
    transition: '250ms ease-in-out',
    '&:after': {
      transition: '250ms ease-in-out',
      left: '0rem'
    }
  },
  checkbox: {
    border: 0,
    clip: 'rect(0 0 0 0)',
    clippath: 'inset(50%)',
    height: '1px',
    margin: '-1px',
    overflow: 'hidden',
    padding: 0,
    position: 'absolute',
    whiteSpace: 'nowrap',
    width: '1px'
  },
  labelText: {
    position: 'absolute',
    font: {
      size: '1.6rem',
      lineHeight: '2rem',
      weight: 600
    },
    letterSpacing: '0.02rem',
    top: '50%',
    transform: 'translate(0,-50%)'
  },
  labelTextActive: {
    left: 'calc(100% + 0.7rem)',
    transition: '150ms ease-in-out',
    color: colors.blue[600]
  },
  labelTextInactive: {
    right: 'calc(100% + 0.7rem)',
    transition: '150ms ease-in-out',
    color: colors.neutral[800]
  }
};

var createStyles = createUseStyles(styles);

export { createStyles };
//# sourceMappingURL=styles.js.map